module.exports = __webpack_public_path__ + "img/setting_icon_selected.f4ded5bd.svg";